module.exports = __webpack_public_path__ + "img/pageinteriors_02administracion-de-riesgos-01.88472230.jpg";